import styled from "styled-components";

import { SimpleUserInitialsNameContainer } from "shared/components/atoms/SimpleUserInitials/styles";

export const SingleAuthorContainer = styled.button`
  cursor: pointer;
  background-color: transparent;
  border: none;
  width: fit-content;

  display: flex;
  gap: 0.5rem;
  padding: 0.625rem 0;

  .user-infos {
    display: flex;
    align-items: center;
  }

  .userPhoto {
    width: 24px;
    height: 24px;
    padding: 0;
    border-radius: 50%;
  }

  ${SimpleUserInitialsNameContainer} {
    width: 24px;
    height: 24px;
  }

  .user-text-infos {
    align-items: flex-start;
    display: flex;
    flex-direction: row;
    gap: 0.5rem;
    margin-left: 1rem;
  }

  .userName {
    font-weight: 700;
    color: ${({ theme }) => theme.groups.primaryText};
    font-size: 14px;
    max-width: 12rem;

    text-align: start;
    display: block;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .userEmail {
    font-weight: 400;
    color: ${({ theme }) => theme.groups.secondaryText};
    font-size: 14px;
    text-align: start;
    max-width: 12rem;

    display: block;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;
